import { ApprovalTypes } from 'ui-product-approvals-common';
import type { ApprovalType } from 'ui-product-approvals-common';

// Deals and quotes manage their approvers in their own settings, not by
// reassigning an individual approval.
export const isReassignSupportedForType = (approvalType: ApprovalType) =>
  approvalType !== ApprovalTypes.DEAL && approvalType !== ApprovalTypes.QUOTE;
